import { Action } from 'react-fetching-library';

export const getCurrentUser: Action = {
  method: 'GET',
  endpoint: 'users/me',
};
